module.exports = __webpack_public_path__ + "static/media/animated-landing.f495f129.gif";